<router-outlet />

